<template>
  <div style="height: calc(100vh - 90px);">
    <h2>Telegram бот <small>https://t.me/hyper_script_bot</small></h2>
    <div class="frame-wrapper">
    <vue-friendly-iframe
      :src="iframeSrc"
      @mouseenter="$store.commit('setNewTlgMessages', false)"
      name="content-frame"
    />
    </div>
  </div>
</template>
<script>
const envIframeSrc = process.env.VUE_APP_BOT_URL;
export default {
  name: "TelegramBot",
  data() {
    return {
      iframeSrc:envIframeSrc,
    }
  },
  mounted() {
    this.$store.commit('setNewTlgMessages', false)
  }
}
</script>
<style>
.frame-wrapper, .vue-friendly-iframe, .vue-friendly-iframe iframe {
  height: 100%;
  width: 100%;
}
</style>
